<template>
    <div class="result-detail">
		<div class="contents">
			<h3 class="mark">
				<div class="type">
					<span>
						<img src="../assets/result-detail-output-icon01.svg" alt="*" />あなたのアウトプット性質
					</span>
				</div><!-- end .type -->
				<div class="cover">
					創出型{{outputResult.percentageLeft}}%、操縦型{{outputResult.percentageRight}}%
				</div><!-- end .cover -->
			</h3><!-- end .mark -->
			<div class="sentence">
				<div class="catch">
					<span class="left">
						Detailed
					</span>
					<span class="right">
						explanation
					</span>
				</div><!-- end .catch -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<h2>一直線にアウトプットする力があり、答えが明確で、やるべきことがシンプルな時ほど強い</h2>
				<img src="../assets/result-detail-output-outright01.svg" alt="*" class="visual" />
				<div class="caption">
					マニュアルや攻略本などを手にした場合、あなたは他のタイプよりも大きな成果を出すことができる
				</div><!-- end .caption -->
				<p>この項目では、あなたのアウトプットの経験値や能力について検査しました。人生は何をアウトプットするかで決まるといっても過言はありません。私たちは自分たちが合うプットしたものを価値に変えて生活しています。</p>
				<p>診断の結果、あなたは非常に具体的なマニュアルやルールの定められたアウトプットを好む傾向があると分かりました。答えが明確で、やるべきことがシンプルな際、あなたは一直線に成果を出すことができます。</p>
				<p>攻略本を持っていれば、誰しもが高いパフォーマンスを出せるかというとそうではありません。攻略法が分かってしまった時点で、気持ちが萎えるタイプも存在します。その点、あなたは、攻略法が分かると、俄然やる気が出て突っ走ることができるタイプです。</p>
				<p>これは、あなたの持つ外向性の高さと非常にマッチします。つまり、あなたは自分の外向性に適したアウトプットをしているのです。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<h2>適切な具体策が用意された場所で、あなたは強く輝ける</h2>
				<img src="../assets/result-detail-output-outright02.svg" alt="*" class="visual" />
				<div class="caption">
					難しい課題や専門性が高いタスクは自分だけのアウトプットに頼らず、他人やツールにアウトソーシングするべきだ
				</div><!-- end .caption -->
				<p>外向度が高く、アウトプットが操縦型の人は、適切な具体策が用意された場所で、一直線にそれに打ち込むことができます。内向度が高かったり、アウトプットが創出型だったりすると、具体策が用意された場所でも、思考がさまよいます。彼らは我流にしたり、アレンジしたり、シンプルにそれ通りにすることが苦手なのです。</p>
				<p>そう考えると、外向度が高く、アウトプットが操縦型のあなたは、いかに具体策を手に入れるかが成功や達成において重要だと言えるでしょう。具体策を手に入れるために、周囲から素直にアドバイスを聞いたり、専門家にお金を払って相談したりすることが大切です。</p>
				<p>自分でアウトプットすることにこだわらず、自分が他人や他のシステムを使って、代わりにアウトプットしてもらうという発想があなたの持っている能力を有効に活用するポイントです。</p>
				<p>一人であれこれと悩むということは、非常に抽象的な行為です。悩んでいるとき、それは自分が曖昧なゾーンに入っていると認知するようにしましょう。すると、自然に他人からの相談や他者の情報へリーチしていくようになります。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<h2>具体策を実験的にチャレンジできるようになれば、あなたの価値はどんどん高騰する</h2>
				<img src="../assets/result-detail-output-outright03.svg" alt="*" class="visual" />
				<div class="caption">
					自分の行動パターンや思考パターンを常に複数持って、新しい行動や思考を定期的に取り入れるようにする
				</div><!-- end .caption -->
				<p>外向度が高く、アウトプットが操縦型であることの一番のリスクは、マニュアル人間になってしまうことです。マニュアル人間というのは、無思考なイメージがありますよね。マニュアルに載っていること以外ができずに、自分自身で考えて行動ができないような人に揶揄される言葉です。</p>
				<p>世の中で高い価値を持つものは、その人にしかできないオリジナリティに溢れているものですよね。ですから、内向性が高く、創造的なアウトプットに長けている人は、個として高い価値を出しやすいと言えます。</p>
				<p>しかし、真逆の外向度が高く、アウトプットが操縦型のあなたにも活路は十分にあります。その活路とは、具体策をどんどんトライ＆エラーしていくことです。具体策を見つけては実践し、検証し、また次の具体策へ移行する。この行動こそが、あなたの価値をどんどん上げる秘訣です。</p>
				<p>今の世の中、無料で使えるシステムやツールはたくさんあります。お金を払えば、さらに良いシステムやツールを扱えます。ビデオなどビジュアルで表現された具体的な情報を享受できる時代です。本来、成功に必要な内向性をショートカットして、行動を続けるだけで大きな成功へたどり着く時代でもあります。</p>
				<p>「何事も実験してみよう！」というマインドは、まずは具体策を投じて、その結果をもとに、次の具体策を決めるという非常に具体的な行動ですよね。こうした行動が、今のあなたにはとてもぴったりです。また、行動と検証の豊富な繰り返しは、あなたの内向度を深める機会にもなります。実験思考の繰り返しが、あなたの価値をどんどん高め、歳を重ねるほどにあなたの人生はワクワクするものになっていくでしょう。</p>
			</div><!-- end .sentence -->
		</div><!-- end .guidance -->
    </div><!-- end .result-index -->				
</template>

<script>


export default {
	name: 'ResultDetailOutputOutRight',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},		
		// output
		outputResult:function(){
			return this.$store.getters.outputResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
